import taxonomy from './storeTaxonomyData.json';

const buildOptionToLabelMap = options =>
  options.reduce((acc, item) => {
    return item?.option ? { ...acc, [item.option]: item.label } : acc;
  }, {});

const buildLabelToOptionMap = options =>
  options.reduce((acc, item) => {
    return item?.label ? { ...acc, [item.label]: item.option } : acc;
  }, {});

export const STORE_SIDEBAR_CATEGORIES = taxonomy?.categories || [];
export const STORE_SIDEBAR_SUBCATEGORIES = taxonomy?.subcategories || [];

export const STORE_SIDEBAR_CATEGORY_LABELS = buildOptionToLabelMap(STORE_SIDEBAR_CATEGORIES);
export const STORE_SIDEBAR_CATEGORY_BY_LABEL = buildLabelToOptionMap(STORE_SIDEBAR_CATEGORIES);
export const STORE_SIDEBAR_SUBCATEGORY_LABELS = buildOptionToLabelMap(STORE_SIDEBAR_SUBCATEGORIES);
export const STORE_SIDEBAR_SUBCATEGORY_BY_LABEL = buildLabelToOptionMap(STORE_SIDEBAR_SUBCATEGORIES);

export const STORE_SIDEBAR_SUBCATEGORY_TO_CATEGORY = STORE_SIDEBAR_SUBCATEGORIES.reduce(
  (acc, item) => {
    return item?.option && item?.category ? { ...acc, [item.option]: item.category } : acc;
  },
  {}
);

export const STORE_SIDEBAR_SUBCATEGORIES_BY_CATEGORY = STORE_SIDEBAR_CATEGORIES.reduce(
  (acc, category) => {
    const categoryOption = category?.option;
    if (!categoryOption) {
      return acc;
    }

    return {
      ...acc,
      [categoryOption]: STORE_SIDEBAR_SUBCATEGORIES.filter(
        subcategory => subcategory?.category === categoryOption
      ),
    };
  },
  {}
);

export const normalizeLegacySubcategorySlug = slug => {
  if (!slug) {
    return slug;
  }

  if (STORE_SIDEBAR_SUBCATEGORY_LABELS[slug]) {
    return slug;
  }

  const normalized = String(slug).replace(/-only(archery|hunting|fishing)$/i, '');
  return STORE_SIDEBAR_SUBCATEGORY_LABELS[normalized] ? normalized : slug;
};

export const getCategoryLabel = category => STORE_SIDEBAR_CATEGORY_LABELS[category] || '';

export const getSubcategoryLabel = subcategory =>
  STORE_SIDEBAR_SUBCATEGORY_LABELS[normalizeLegacySubcategorySlug(subcategory)] || '';

export const getSubcategoryCategory = subcategory =>
  STORE_SIDEBAR_SUBCATEGORY_TO_CATEGORY[normalizeLegacySubcategorySlug(subcategory)] || null;

export const getSubcategoriesForCategory = category => {
  if (!category || category === 'all') {
    return STORE_SIDEBAR_SUBCATEGORIES;
  }

  return STORE_SIDEBAR_SUBCATEGORIES_BY_CATEGORY[category] || [];
};
